<template>
  <auto-height :margin="8" class="group-message-list-container">
    <common-bulk-message-list
      ref="list"
      :url="indexUrl"
      class="list h-100 overflow-auto"
    >
      <template v-slot="slotProps">
        <common-bulk-message-list-item
          :key="slotProps.item.id"
          v-bind="slotProps"
          @show-messages="showMessages"
          @refresh-list="refreshList"
        ></common-bulk-message-list-item>
      </template>
    </common-bulk-message-list>
    <sms-message-list
      v-if="shouldDisplaySmsMessageList"
      :bulk-message="display.item.bulk_message"
      @close="onClose"
    ></sms-message-list>
    <schedule-preview-message-list
      v-if="shouldDisplaySmsMessagePreviewList"
      :bulk-message="display.item.bulk_message"
      @close="onClose"
    ></schedule-preview-message-list>
    <EmailMessageList
      v-if="shouldDisplayEmailMessageList"
      :email-bulk-message="display.item.email_bulk_message"
      @close="onClose"
    ></EmailMessageList>
  </auto-height>
</template>

<script>
import CommonBulkMessageList from '../../../../components/common-bulk-message/list';
import SmsMessageList from './sms-message-list';
import CommonBulkMessageListItem from './common-bulk-message-list-item';
import AutoHeight from '../../../../components/auto-height';
import SchedulePreviewMessageList from "../schedule/schedule-preview-message-list";
import EmailMessageList from "./email-message-list.vue";


export default {
  components: {
    EmailMessageList,
    'schedule-preview-message-list': SchedulePreviewMessageList,
    'common-bulk-message-list': CommonBulkMessageList,
    'sms-message-list': SmsMessageList,
    'auto-height': AutoHeight,
    'common-bulk-message-list-item': CommonBulkMessageListItem,
  },

  props: {
    sendList: null,
  },

  data() {
    return {
      display: null,
    };
  },

  computed: {
    /**
     * @return {string|null}
     */
    indexUrl() {
      return _.get(this.sendList, 'commonBulkMessageListUrl', null);
    },

    /**
     * @return {string|null}
     */
    displayType() {
      return _.get(this.display, 'type', null);
    },

    /**
     * @return {boolean}
     */
    shouldDisplaySmsMessageList() {
      return this.displayType === 'sms-message-list';
    },

    /**
     * @return {boolean}
     */
    shouldDisplaySmsMessagePreviewList() {
      return this.displayType === 'sms-message-preview-list';
    },

    /**
     * @return {boolean}
     */
    shouldDisplayEmailMessageList() {
      return this.displayType === 'email-message-list';
    },
  },

  methods: {
    /**
     * @param {Object} payload
     */
    showMessages(payload) {
      this.display = payload;
    },

    /**
     * @return {undefined}
     */
    onClose() {
      this.display = null;
    },

    /**
     * @return {undefined}
     */
    refreshList() {
      this.$refs.list.refresh();
    },
  },

  mounted() {
    eventBus.$on('bulk-message-created', this.refreshList);
    eventBus.$on('email-bulk-message-created', this.refreshList);
  },

  beforeDestroy() {
    eventBus.$off('bulk-message-created', this.refreshList);
    eventBus.$off('email-bulk-message-created', this.refreshList);
  }
}
</script>

